import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Label,
  Input,
  Button,
  Alert,
  Popover,
  PopoverHeader,
  PopoverBody,
  Breadcrumb,
  BreadcrumbItem,
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  ModalFooter,
  Table,
} from "reactstrap";
import Tooltip from "../../../components/UI/TooltipIcon/TooptipIcon";
import ErrorMessage from "../../../components/Message/ErrorMessage/ErrorMessage";
import { deepClone } from "../../../utils/copyObject";
import findIndex from "lodash/findIndex";
import find from "lodash/find";
import filter from "lodash/filter";
import axios from "../../../axios";
import { profilePicValidityCheck, roleOptions } from "../../../utils/constants";
import addIcon from "../../../assets/plus.svg";
import { validateEmail } from "../../../utils/validations";
// import Loading from '../../../hoc/Loading/LoadingWithError';
import Loading from "../../../hoc/Loading/Loading";
import { MdCheck } from "react-icons/md";

import { BiCheck, BiPlus, BiTrashAlt } from "react-icons/bi";
import { toastContainer } from "../../../utils/toast";
import { Link } from "react-router-dom";

import { loadStripe } from "@stripe/stripe-js";
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";

import {
  getTrivvyPlanDetailsPlanWise,
  RECURRING_PLAN_PRICE_DATA,
} from "../data";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions";
import { STRIPE_PUBLIC_KEY } from "../../../utils/constants";
import { isMobile } from "../../../utils/deviceInfo";
import OoPopover from "../../../components/UI/Popover/OoPopover";

export default function PlanInquiryForm({ open, onClose, user }) {
    const [message,setMessage] = useState("")
  const sendInquiry = () => {
    const organizationName = user.profile.organizationId.name;
    const planName = "Enterprise";

    

    axios
      .post(url.sendPlanInquiryEmail, {
        organizationName,
        planName,
      })
      .then(({ data }) => {
        toastContainer("Inquiry sent successfully", "success");
      })
      .catch((err) => {
        toastContainer("Error while sending inquiry", "error");
      });
  };
  return (
    <Modal isOpen={open}>
      <ModalHeader className="trivia_modal_header_bg" toggle={onClose}>
        Get Quote
      </ModalHeader>
      <ModalBody className={isMobile ? "p-2" : "p-4"}>
        <div
          style={{
            width: "90%",
            margin: "auto",
          }}
        >
          <h5 className="mb-4 text-center">
            Contact with our sales deck for the Quote of Enterprise plan
          </h5>
          <div className="my-3">
            <Label> Message </Label>
            <Input value={message} onChange={(e)=> setMessage(e.target.value) } type="textarea" rows={5} />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="pr-5">
        <Button className={"trivia-action-button-main"} onClick={sendInquiry}>
          Send Inquiry{" "}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
